import { render, staticRenderFns } from "./QResourceMenuField.vue?vue&type=template&id=1e25a99e&"
import script from "./QResourceMenuField.vue?vue&type=script&lang=js&"
export * from "./QResourceMenuField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports